import request from "@/request";

export function auth(data) {
  return request({
    url: '/ajax/auth',
    method: 'get',
    params: data,
  })
}